import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Api from "../utils/api";
import { CircularProgress, Box } from "@mui/material"; // Import Material UI components
import { useError } from "../contexts/ErrorContext";

const Security: React.FC = () => {
    const [isValid, setIsValid] = useState<boolean | null>(null);
    const { showError } = useError();
    useEffect(() => {
        const validateToken = async () => {
            let isTokenValid = false;
            if (localStorage.getItem('expiresAt')) {
                if (Date.now() > Number(localStorage.getItem('expiresAt'))) {
                    localStorage.removeItem("accessToken");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("expiresAt");
                    showError("Session expired. Please log in again.");
                }
            }
            const accessToken = localStorage.getItem("accessToken") || "";
            if (accessToken) {
                try {
                    isTokenValid = await Api.handleTokenValidation();
                }
                catch (e: any) {
                    console.log(e);
                    showError(e.message);
                }
            }

            setIsValid(isTokenValid);
        };

        validateToken();
    }, []);

    // Show Material UI Loader while checking token
    if (isValid === null) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100vh" // Full height of the viewport
            >
                <CircularProgress />
            </Box>
        );
    }

    return isValid ? <Outlet /> : <Navigate to="/login" replace />;
};

export default Security;
